import { useEffect, useState } from 'react';
import moment from 'moment';


// material-ui
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import FilterListIcon from '@mui/icons-material/FilterListTwoTone';


// project import
import BoardBookingChart from './BoardBookingChart';
import BoardUsageChart from './BoardUsageChart';
import { gridSpacing } from 'store/constant';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import RevenueCard from 'ui-component/cards/RevenueCard';
// import { NumberLocale } from 'store/TextFormat';
import Filter from './StaticFilter';
// import { display } from '@mui/system';
// import { filter } from 'lodash';
// import { useParams } from 'react-router-dom';

const BoardStatistics = ({ boardUuid }) => {

    const theme = useTheme();
    // const backColor = theme.palette.background.paper;
    const primary = theme.palette.primary.main;
    const secondary = theme.palette.secondary.main;
    // const error = theme.palette.error.main;
    // const info = theme.palette.info.main;
    const success = theme.palette.success.main;

    const [openFilter, setOpenFilter] = useState(false);

    const [isLoading, setLoading] = useState(true);
    const [statData, setStatData] = useState({ active_time: 0, usage_time: 0, used_amount: 0 });
    const [filterObj, setFilterObj] = useState({ start_date: '', end_date: '' });
    const [boardUsage, setBoardUsage] = useState({
        height: 480,
        type: 'bar',
        options: {
            chart: {
                id: 'board-booking-chart',
                stacked: false,
                toolbar: { show: false },
                zoom: { enabled: false }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: { position: 'bottom', offsetX: -10, offsetY: 0 }
                    }
                }
            ],
            plotOptions: {
                bar: { horizontal: false, columnWidth: '50%' }
            },
            xaxis: {
                type: 'category',
                categories: [],
                labels: { style: { fontFamily: `'Roboto', sans-serif` } }
            },
            yaxis: {
                title: {
                    text: 'Duration in Hours',
                    style: { fontFamily: `'Roboto', sans-serif`, fontSize: '14px', fontWeight: 600 }
                },
                labels: {
                    // formatter: function (value) {
                    //     return Math.round(value); // Rounds the y-axis labels to the nearest integer
                    // }, 
                    style: { fontFamily: `'Roboto', sans-serif`, fontSize: '12px' }
                },
            },
            legend: {
                show: true,
                fontFamily: `'Roboto', sans-serif`,
                position: 'bottom',
                offsetX: 20,
                labels: { useSeriesColors: false },
                markers: { width: 16, height: 16, radius: 5 },
                itemMargin: { horizontal: 15, vertical: 8 }
            },
            fill: { type: 'solid' },
            dataLabels: { enabled: false },
            grid: { show: true }
        },
        series: []
    });
    const [userUsage, setUserUsage] = useState({
        height: 480,
        type: 'bar',
        options: {
            chart: {
                id: 'board-booking-chart',
                stacked: true,
                toolbar: { show: false },
                zoom: { enabled: false }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: { position: 'bottom', offsetX: -10, offsetY: 0 }
                    }
                }
            ],
            plotOptions: { bar: { horizontal: false, columnWidth: '50%' } },
            xaxis: {
                type: 'category',
                categories: [],
                labels: {
                    style: { fontFamily: `'Roboto', sans-serif` }
                }
            },
            yaxis: {
                title: {
                    text: 'Duration in Minutes',
                    style: { fontFamily: `'Roboto', sans-serif`, fontSize: '14px', fontWeight: 600 }
                },
                labels: {
                    // formatter: function (value) {
                    //     return value;
                    // },
                    style: { fontFamily: `'Roboto', sans-serif`, fontSize: '12px' }
                },
                axisBorder: { show: true, color: '#ccc' },
                axisTicks: { show: true, color: '#ccc' }
            },
            colors: ['#26e7a6'],
            legend: {
                show: false,
                fontFamily: `'Roboto', sans-serif`,
                position: 'bottom',
                offsetX: 20,
                labels: { useSeriesColors: false },
                markers: { width: 16, height: 16, radius: 5 },
                itemMargin: { horizontal: 15, vertical: 8 }
            },
            fill: { type: 'solid' },
            dataLabels: { enabled: false },
            grid: { show: true }
        },
        series: []
    });

    const formatSecondsToMinutes = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        const minutessLabel = minutes <= 0 ? 'min' : 'mins'
        const secondsLabel = seconds <= 0 ? 'sec' : 'secs'
        return `${minutes} ${minutessLabel} ${remainingSeconds.toString().padStart(2, '0')} ${secondsLabel}`;
    };

    const handleCloseDialog = () => {
        setOpenFilter(false);
    };

    const handleClickOpenDialog = () => {
        setOpenFilter(true);
    };

    const formatDate = (date) => {
        if (date) {
            const formattedDate = moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
            return formattedDate;
        } else {
            return '';
        }
    };

    const successHandler = (resp) => {
        const data = resp.data;
        const dupboardUsage = boardUsage;
        dupboardUsage.options.xaxis.categories = data.boardUsage.categories;
        dupboardUsage.series = data.boardUsage.series;
        setBoardUsage(dupboardUsage);
        const dupuserUsage = userUsage;
        dupuserUsage.options.xaxis.categories = data.userUsage.categories;
        dupuserUsage.series = data.userUsage.series;
        setUserUsage(dupuserUsage);
        setLoading(false);
    };

    const statByDateHandler = (resp) => {
        setStatData(resp.data);
    };

    const dashboardApi = useApi(VenueService.getBoardStatistics, successHandler);
    const dashboardApiStatByDate = useApi(VenueService.getBoardStatisticsByDate, statByDateHandler);

    useEffect(() => {
        dashboardApi.execute(boardUuid);
    }, []);

    useEffect(() => {
        dashboardApiStatByDate.execute(boardUuid, {
            filter: filterObj
        });
    }, [filterObj]);

    return (
        <>
            <Grid container spacing={gridSpacing} sx={{ marginTop: '5px' }}>
                <Grid lg={12} sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Typography variant='h4' sx={{ mt: 1, pr: 2 }}>
                        {filterObj.start_date ? `${formatDate(filterObj.start_date)} - ${formatDate(filterObj.end_date)}` : 'No Filtered'}
                    </Typography>
                    <Tooltip title="Filter">
                        <IconButton
                            size="large"
                            onClick={handleClickOpenDialog}
                            sx={{ boxShadow: 'none', ml: 1, width: 32, height: 32, minHeight: 32 }}
                        >
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid container spacing={gridSpacing} sx={{ marginLeft: 0, marginTop: '2px' }}>
                    <Grid item xs={12} lg={4} md={12}>
                        <RevenueCard
                            primary="Total Active Time"
                            secondary={`${formatSecondsToMinutes(statData.active_time)}`}
                            iconPrimary={AccessTimeOutlinedIcon}
                            color={primary}
                        />
                    </Grid>
                    <Grid item xs={12} lg={4} sm={6}>
                        <RevenueCard
                            primary="Total Usage Time"
                            secondary={`${formatSecondsToMinutes(statData.usage_time)}`}
                            iconPrimary={AccessTimeOutlinedIcon}
                            color={secondary}
                        />
                    </Grid>
                    <Grid item xs={12} lg={4} sm={6}>
                        <RevenueCard
                            primary="Total Usage Amount"
                            secondary={`₹${statData.used_amount}`}
                            iconPrimary={CurrencyRupeeIcon}
                            color={success}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} lg={6} sm={6}>
                    <BoardBookingChart
                        isLoading={isLoading}
                        title="Board Bookings Used Hours"
                        chartData={boardUsage}
                    />
                </Grid>
                <Grid item xs={12} lg={6} sm={6}>
                    <BoardUsageChart
                        isLoading={isLoading}
                        title="User Used Minutes"
                        chartData={userUsage}
                    />
                </Grid>
                <Filter
                    filterObj={filterObj}
                    open={openFilter}
                    handleCloseDialog={handleCloseDialog}
                    setFilterObj={setFilterObj}
                    statData={statData} />
            </Grid>
        </>
    );
};

export default BoardStatistics;